import { Component, OnInit,ViewChild,ElementRef,Directive } from '@angular/core';
import { Options } from 'select2';
import { Select2OptionData } from 'ng-select2';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { ServiceMsg } from 'src/app/utils/common/validate-msg-aas';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertComponent } from 'src/app/layout/extensions/alert/alert.component';
import { NgModalComponent } from 'src/app/layout/extensions/ng-modal/ng-modal.component';
import { AasEinvoicesService } from 'src/app/utils/services/aas-network/aas-einvoices.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountItem } from 'src/app/utils/models/aas-models/einvoices-manager/account-einvoices/account-item.model'
import { AccountObjectResponse } from 'src/app/utils/models/aas-models/einvoices-manager/account-einvoices/account-object-response.model'
import { ResponseMsg } from 'src/app/utils/common/response-msg-aas';

@Component({
  selector: 'app-account-envoices-detail',
  templateUrl: './account-envoices-detail.component.html',
  styleUrls: ['./account-envoices-detail.component.scss']
})
export class AccountEnvoicesDetailComponent implements OnInit {
  uuid = this.router.snapshot.paramMap.get('id');

  validateMsg = ServiceMsg.EINVOICES_CUSTOMER_CREATE;
  isSubmit: boolean = false;
  form : FormGroup;

  accountItem : AccountItem;
  accountObjectRes : AccountObjectResponse;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private einvoicesService: AasEinvoicesService,
    private router: ActivatedRoute,
    private route: Router,

  ) { }

  ngOnInit(): void {
    this.makeFormCustomerInvoice();
    this.getDetailAccEinvoices();
  }

  makeFormCustomerInvoice(){
    this.form = this.fb.group({
      companyName : ['',Validators.required],
      taxCode: ['',Validators.required],
      accountInvoice: ['',Validators.required],
      passwordInvoice: ['',Validators.required],
      url: ['',Validators.required],
      serviceAccount: ['',Validators.required],
      servicePassword: ['',Validators.required],
      pattern: ['',Validators.required],
      serial: ['',Validators.required]
    })
  }

  get companyName() {
    return this.form.get('companyName');
  }
  get taxCode() {
    return this.form.get('taxCode');
  }
  get accountInvoice() {
    return this.form.get('accountInvoice');
  }
  get passwordInvoice() {
    return this.form.get('passwordInvoice');
  }
  get url() {
    return this.form.get('url');
  }
  get serviceAccount() {
    return this.form.get('serviceAccount');
  }
  get servicePassword() {
    return this.form.get('servicePassword');
  }

  get pattern(){
    return this.form.get('pattern')
  }

  get serial(){
    return this.form.get('serial')
  }
// GET THÔNG TIN CHI TIẾT CỦA TÀI KHOẢN
  getDetailAccEinvoices(){
    this.einvoicesService.getAccEinvoiceDetail(this.uuid).subscribe(res=>{
      this.accountObjectRes = new AccountObjectResponse(res)
      this.accountItem = this.accountObjectRes.object
      this.form.setValue({
        companyName : this.accountItem.companyName,
        taxCode: this.accountItem.taxCode,
        accountInvoice: this.accountItem.account,
        passwordInvoice: this.accountItem.password,
        url: this.accountItem.url,
        serviceAccount: this.accountItem.serviceAccount,
        servicePassword: this.accountItem.servicePassword,
        pattern: this.accountItem.pattern,
        serial: this.accountItem.serial
      })
    }, err => {
      console.log(err);
      this.handleError(err, ResponseMsg.MESSAGES.ALL_IN_ONE);
    })
  }
  // hủy thay đổi
  cancelData(){
    this.makeFormCustomerInvoice();
  }
  // save dữ cập nhập
  saveData(){
    let data = this.form.value
    console.log(data, '=========data')
    this.modal("Bạn chắc chắn muốn khởi tạo tài khoản hóa đơn điện tử này?", () => {
       this.createAccCustomer(data)

    });
  }
  // cập nhập dữ liệu
  createAccCustomer(data){
    this.einvoicesService.postCreateAccEinvoice(data).subscribe(res=>{
      console.log(res)
    })
  }

  //MARK: Popup thông báo
  modal(msg, callBack = () => { }) {
    const modalRef = this.modalService.open(NgModalComponent);
    modalRef.componentInstance.message = msg;
    modalRef.componentInstance.callback = callBack;
  }

   //MARK: Popup thông báo
   alert(msg, type, twoBtn = false, iconBtn2 = '', titleBtn2 = 'OK', actBtn2 = () => { }, iconBtn1 = '', titleBtn1 = 'Hủy', actBtn1 = () => { }) {
    const modalRef = this.modalService.open(AlertComponent);
    modalRef.componentInstance.message = msg;
    modalRef.componentInstance.typeAlert = type;
    modalRef.componentInstance.twoBtn = twoBtn;
    modalRef.componentInstance.iconBtn1 = iconBtn1;
    modalRef.componentInstance.iconBtn2 = iconBtn2;
    modalRef.componentInstance.titleButton1 = titleBtn1;
    modalRef.componentInstance.titleButton2 = titleBtn2;
    modalRef.componentInstance.callback1 = actBtn1;
    modalRef.componentInstance.callback2 = actBtn2;
  }

  //MARK: Handle Error
  handleError(err, errorMsg) {
    if (err.error && err.error.message && errorMsg[err.error.message]) {
      this.alert(errorMsg[err.error.message], 'error');
    } else if (err.error && err.error.error) {
      this.alert(err.error.error, 'error');
    } else {
      this.alert('Lỗi không xác định!', 'error');
    }
  }



}
